import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import * as ApiHelper from "../../../ApiHelper"
import Moment from "moment"
import { TableLayout } from "../../../components"
import { ToastContainer, ToastMessage } from "react-toastr"
class TableDigitalizadosTrash extends Component {
  constructor() {
    super()
    this.toastFactory = React.createFactory(ToastMessage.animation)
    this.restore = this.restore.bind(this)
    this.getArquivo = this.getArquivo.bind(this)
    this.state = {
      showLoad: false
    }
  }

  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000
    })
  }
  restore(id) {
    ApiHelper.restoreContratoDigitalizado(id, error => {
      if (error) {
        this.addAlert("", error.message)
      } else {
        this.props.onRestore()
      }
    })
  }
  getLastPathComponent(url) {
    var urlChanged = url
    urlChanged = urlChanged.substr(urlChanged.lastIndexOf("/") + 1)
    return urlChanged
  }
  getArquivo(url) {
    var tempLink = document.createElement("a")
    tempLink.href = url
    tempLink.setAttribute("target", "_blank")
    document.body.appendChild(tempLink)
    tempLink.click()
    document.body.removeChild(tempLink)
  }
  render() {
    var tableHeaders = ["Nome do arquivo", "Adicionado em", "Ações"]
    return (
      <div>
        <ToastContainer
          ref={input => {
            this.container = input
          }}
          toastMessageFactory={this.toastFactory}
          className="toast-top-right"
          preventDuplicates={true}
        />
        <TableLayout
          headerButtons={[]}
          sizeClass={this.props.sizeClass}
          backgroundColor={this.props.backgroundColor}
          title={this.props.title}
          subtitle={this.props.subtitle}
          filter={this.props.filter}
          searchLabel="Pesquisar contrato digitalizado"
        >
          <table className="table table-hover">
            <thead className="text-warning">
              <tr>
                {tableHeaders.map((header, key) => {
                  return <th key={key}>{header}</th>
                })}
              </tr>
            </thead>
            <tbody>
              {this.props.rows.map((row, key) => {
                return (
                  <tr key={key}>
                    {
                      <td className="col-md-10">
                        {this.getLastPathComponent(row.nome)}
                      </td>
                    }
                    <td className="col-sm-2">
                      {Moment(row.created_at).format("D/MM/Y")}
                    </td>
                    <td className="col-sm-3 td-actions text-right">
                      <button
                        type="button"
                        rel="tooltip"
                        title="Restaurar contrato digitalizado"
                        onClick={() => this.restore(row.id)}
                        className="btn btn-danger btn-simple btn-xs"
                      >
                        <i className="material-icons">restore</i>
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </TableLayout>
      </div>
    )
  }
}
export default withRouter(TableDigitalizadosTrash)



// WEBPACK FOOTER //
// ./src/views/contratos/digitalizados/TableDigitalizadosTrash.js